import React from 'react'
import { graphql, Link } from 'gatsby'

import Carousel from '../../components/carousel'
import Layout from '../../components/layout'
import SEO from '../../components/seo'


export default ({ data }) => {
  const images = [
    { img: data.i1, caption: 'Flying a Wall Panel into place' },
    { img: data.i2, caption: 'Flying a Wall Panel into place' },
    { img: data.i3, caption: 'Flying a Wall Panel into place' },
    { img: data.i4, caption: 'Shooting Wall Panels down' },
  ];

  return (
    <Layout>
      <SEO title="System Overview: Installing Wall Panels" keywords={[]}/>
      <div className="container system-overview-container">
        <h2 className='subtitle subtitle--xl color-primary'>System Overview</h2>
        <h1 className='title title--xxxl color-primary'>Installing Wall Panels</h1>

        <div className='grid grid--gutterless'>
          <div className='grid__column grid__column--12 grid__column--4--md'>
            <p>The wall panels are lifted off the truck and "flown" to their proper location per
            the PanelCAD wall panel layout / shop drawings. The panels are then attached to the
            supporting slab with powder actuated fasteners, expansion anchors, or other means.</p>
            <p className='type--lg'>
              <Link className="link-next" to="/system-overview/lateral-loads/">
                Next Page: Lateral Loads
              </Link>
            </p>
            <p>
              <Link className="link-prev" to="/system-overview/metal-stud-walls/">
                Prev Page: Metal Stud Walls
              </Link>
            </p>
          </div>

          <div className='grid__column grid__column--12 grid__column--8--md'>
            <div className='carousel-container carousel-container--padding-x'>
              <Carousel
                content={images}
                carWidth={474}
                carHeight={316}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
    query {
        i1: file(relativePath: { eq: "system-overview/installing-wall-panels/gallery/01-CityP010_(33891).png" }) { 
            ...SystemOverviewCarouselImageFragment },
        i2: file(relativePath: { eq: "system-overview/installing-wall-panels/gallery/02-WallP170_(replacement)_(33902).png" }) { 
            ...SystemOverviewCarouselImageFragment },
        i3: file(relativePath: { eq: "system-overview/installing-wall-panels/gallery/03-WallP140_(40616).png" }) { 
            ...SystemOverviewCarouselImageFragment },
        i4: file(relativePath: { eq: "system-overview/installing-wall-panels/gallery/04-WallP180_(33905).png" }) { 
            ...SystemOverviewCarouselImageFragment },
    }
`
